import React from 'react';
import { fieldTypes, dataTypes, getData } from 'components/course';

const LiveAveragePar = ({ hole, currentRound }) => {
    const holeAverageParOriginal = getData(hole, fieldTypes.rounds, dataTypes.holeAveragePar, currentRound);
    const holeAveragePar = getData(hole, fieldTypes.rounds, dataTypes.holeAveragePar, currentRound) * 100;

    const sign = Math.sign(holeAveragePar);

    let positiveValue = 0;
    let negativeValue = 0;

    if (sign === 1) {
        positiveValue = holeAveragePar.toFixed(2);
    }

    if (sign === -1) {
        negativeValue = Math.abs(holeAveragePar).toFixed(2);
    }

    const isPositiveHorizontalValue = {
        width: `${positiveValue}%`,
    };

    const isNegativeHorizontalValue = {
        width: `${negativeValue}%`,
    };

    const isPositiveValue = {
        height: `${positiveValue}%`,
    };

    const isNegativeValue = {
        height: `${negativeValue}%`,
    };

    return (
        <div className="live-average-par">
            <div className="live-average-par__container">
                <div className="live-average-par__hole-average-par">{holeAverageParOriginal}</div>

                <div className="live-average-par__bar-wrapper">
                    <div className="live-average-par__bar is-positive">
                        <div className="live-average-par__bar-value" style={isPositiveValue}>
                        </div>
                        <div className="live-average-par__bar-value is-horizontal" style={isPositiveHorizontalValue}>
                        </div>
                    </div>
                    <div className="live-average-par__bar is-negative">
                        <div className="live-average-par__bar-value" style={isNegativeValue}>
                        </div>
                        <div className="live-average-par__bar-value is-horizontal" style={isNegativeHorizontalValue}>
                        </div>
                    </div>
                </div>

                <div className="live-average-par__title">average par</div>
            </div>
        </div>
    );
};

export default LiveAveragePar;
